import React from 'react';

export const MoreButtonContext = React.createContext({
  hideComponent: () => {},
});
